import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import get from 'lodash/get';
import { mapState } from 'vuex';
var generator = "const twins = data;\n\nfunction generateGradientColorsByIndex(stateIndex) {\n  const hue = (stateIndex * 63) % 360;\n  const firstColor = `hsl(${hue}, 100%, 50%)`;\n  const secondColor = `hsl(${hue}, 50%, 50%)`;\n  return [firstColor, secondColor];\n}\n\nfunction getSeriesForState(twin, state, stateIndex) {\n  const xyData = [];\n\n  state.history.forEach((dataPoint, index) => {\n    xyData.push([index, dataPoint.value === null ? 0 : dataPoint.value]);\n  });\n\n  const gradientColors = generateGradientColorsByIndex(stateIndex);\n\n  return {\n    name: `${twin.title} - ${state.state.key}`,\n    type: \"line\",\n    stack: \"Total\",\n    smooth: true,\n    lineStyle: {\n      width: 0,\n    },\n    areaStyle: {\n      opacity: 0.8,\n      color: newEchartsObject('graphic.LinearGradient', 0, 0, 0, 1, [\n        {\n          offset: 0,\n          color: gradientColors[0],\n        },\n        {\n          offset: 1,\n          color: gradientColors[1],\n        },\n      ]),\n    },\n    showSymbol: false,\n    emphasis: {\n      focus: \"series\",\n    },\n    data: xyData,\n  };\n}\n\nlet stateIndex = 0;\nfunction getSeriesForTwin(twin) {\n  return twin.states.map((state) => getSeriesForState(twin.twin, state, stateIndex++));\n}\n\nconst series = twins.map((twin) => getSeriesForTwin(twin).flat()).flat();\n\nreturn {\n  tooltip: {\n    trigger: \"axis\",\n    axisPointer: {\n      type: \"cross\",\n      label: {\n        backgroundColor: \"#6a7985\",\n      },\n    },\n  },\n  legend: {},\n  grid: {\n    left: \"3%\",\n    right: \"4%\",\n    bottom: \"3%\",\n    containLabel: true,\n  },\n  xAxis: [\n    {\n      type: \"time\",\n      boundaryGap: false,\n      axisLabel: {\n        formatter: (value) => formatDateTime(value),\n      },\n    },\n  ],\n  yAxis: [\n    {\n      type: \"value\",\n    },\n  ],\n  series: series,\n};\n";
export default {
  name: 'ChartCustomOptionsEditorCodeEditor',
  props: {
    value: {
      type: Object,
      required: true
    },
    showOptionsPreview: {
      type: Boolean,
      required: true
    }
  },
  computed: _objectSpread({}, mapState('app', ['color'])),
  methods: {
    addExampleGenerator: function addExampleGenerator() {
      this.setByKey('chartOptions.custom.optionGenerator', generator);
    },
    getByKey: function getByKey(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      return get(this.value, key, defaultValue);
    },
    setByKey: function setByKey(key, value) {
      var clone = cloneDeep(this.value);
      set(clone, key, value);
      this.$emit('input', clone);
    }
  }
};